export const getVolumeInMillieLiters = (volume: number) => {
  if (!volume) {
    return 0
  }

  return volume * 1000
}
